module.exports = __webpack_public_path__ + "img/landing_page_header.98e1c802.jpg";